<div class="modal-body" id="modal-body">
  <app-translations-detail [pk]="pk" [mode]="mode" [defaults]="defaults" [fieldNameDict]="fieldNameDict"
                           [translatedItem]="translatedItem" [model]="model"
                           (detailSaved)="modal.close($event)" (detailCancelled)="modal.dismiss()">
  </app-translations-detail>
</div>